import type { FC } from 'react';
import { Typography } from '../typography';

/** "No data available" in the middle of a chart's area. */
export const ChartEmptyState: FC = () => (
  <div className="flex h-full items-center justify-center">
    <Typography variant="body" className="text-neutral-7">
      No data available
    </Typography>
  </div>
);
